import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import { Control, Controller, useWatch } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { InputNumber } from 'antd';
import { getShopConfig } from 'constant/shop';

const FinalRecyclePrice = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  const storeId = useWatch({ control, name: 'storeId' });
  const currency = getShopConfig(storeId).currency;
  const type = useWatch({ control, name: 'type' });
  const isFakeBag = useWatch({ control, name: `productList.${index}.isFakeBag` });

  return (
    <div className="flex items-center gap-2">
      <FormLabel required={type === 2 && !isFakeBag}>
        {i18n.t(LOCALS.recycling_confirmation_quote)}:
      </FormLabel>
      <Controller
        name={`productList.${index}.finalRecyclePrice`}
        control={control}
        render={({ field, formState: { errors } }) => (
          <InputNumber
            {...field}
            disabled={type !== 2}
            inputMode="numeric"
            addonBefore={currency}
            className="w-full"
            min={0}
            status={
              errors.productList?.[index]?.finalRecyclePrice
                ? 'error'
                : undefined
            }
            max={99999999}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value!.replace(/\$\s?|(,*)/g, '') as any}
          />
        )}
      />
    </div>
  );
};

export default FinalRecyclePrice;
